export default "__VITE_ASSET__Fy1A3eA7__"